/* eslint-disable react-hooks/exhaustive-deps */
  import React, { useEffect, useContext, useState } from 'react';
  import MainContainer from '../components/MainContainer';
  import Footer from '../components/Footer';
  import '../styles/Home.css';
  import api from '../api';
  import { useParams } from 'react-router-dom';
  import StylesContext from '../context/StylesContext';
  import VideoContext from '../context/VideoContext';
  import VideoPlayer from '../components/VideoPlayer';
  import MainLogoContainer from '../components/MainLogoContainer';
  import StyledContainer from '../components/StyledContainer';
  import MainButtonsContainer from '../components/MainButtonsContainer';
  import TopText from '../components/TopText';
  import StyledImage from '../components/StyleImage';
  import useTextToSpeech from '../hooks/useTextToSpeech';
  import AudioContext from '../context/AudioContext';
  import useAudioDescBtn from '../hooks/useAudioDescBtn';

  function Home() {
    const { styles, setStyles } = useContext(StylesContext);
    const { setSrcId, isVideo, videoSrc } = useContext(VideoContext);
    // const [ textToSpeechHome, setTextToSpeechHome ] = useState<string>('');
    // const { textToSpeech, audioRef } = useTextToSpeech();
    // const {isPlayed, setIsPlayed} = useContext(AudioContext);
    const handleAudio = useAudioDescBtn({urlId: styles.urlId});


    const { menu } = useParams<{menu: string}>();

    const handleClick = () => {
      // if(isPlayed) {
        // if (audioRef.current) {
        //   audioRef.current.pause();
        //   audioRef.current.currentTime = 0;
        // }
        handleAudio();
      // } 
      // else {
      //   if (audioRef.current) {
      //     audioRef.current.pause();
      //     audioRef.current.currentTime = 0;
      //   }
      //   textToSpeech(textToSpeechHome);
      //   setIsPlayed(true);
      // }
    };

    useEffect(() => {
      const getStyles = async () => {
        try {
          const { data } = await api.get(`menu_styles/${menu}`);
          setStyles(data);
          setSrcId(data.urlId);
        } catch(error: any) {
        console.error(error.message);
        }
      }
      getStyles();
    }, [menu]);

    // useEffect(() => {
    //   const getTextToSpeech = async () => {
    //     try {
    //       const { data } = await api.get(`cardapios/${menu}`);          
    //       setTextToSpeechHome(data.homeTextToSpeech);
    //     } catch(error: any) {
    //       console.error(error.message);
    //     }
    //   };
    //   getTextToSpeech();
    // }, []);
    

    return (
      <MainContainer className='home_main_container' $backgroundColor={ styles?.bgColor }>
        { !isVideo ? (
          <>
            <StyledContainer className='home_page_container'>
              <StyledContainer className='Logo_client_home_wrapper' onClick={handleClick}>
                <TopText />
                <MainLogoContainer wrapperClass='logo_home_wrapper' logoClass='logo_home' />
              </StyledContainer>
              <MainButtonsContainer />
            </StyledContainer>
            <Footer $footerLogoColor={ styles.footerColor } />
          </>
        ) : (
          <>
            <StyledContainer className='logo_video_player'>
              <StyledImage src={ styles?.logoImg }/>
            </StyledContainer>
            <StyledContainer className='video_player_home_wrapper'>
              <VideoPlayer src={ videoSrc } autoPlay={true} controls={true} className='home_videoplayer'/>
            </StyledContainer>          
          </>
        )
      }
        </MainContainer>
      )
  }

  export default Home;